<template>
  <v-layout>
    <v-menu
      v-model="menu"
      bottom
      origin="center center"
      transition="scale-transition"
      offset-y
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on }">
        <v-combobox
          v-model="selectedItems"
          :label="label"
          append-icon="edit"
          readonly
          hide-details
          outline
          :height="height"
          multiple
          prepend-inner-icon="query_builder"
          @click:append="menu=true"
        >
          <template v-slot:selection="data">
            <v-chip small>
              {{ data.item }}
            </v-chip>
          </template>
        </v-combobox>
      </template>
      <v-card>
        <v-card-title class="subheading grey--text">
          Редактирование возможных промежутков отгрузки
        </v-card-title>
        <v-card-text class="py-0">
          <v-layout
            column
            align-content-center
          >
            <v-flex
              v-for="(item, index) in items"
              :key="index"
            >
              <v-layout>
                <v-text-field
                  v-model="item.title"
                  :placeholder="label"
                  append-icon="save"
                  hide-details
                  outline
                  :height="height"
                  class="mb-2"
                  @click:append="update(item)"
                />
                <v-btn
                  icon
                  @click="remove(item.id)"
                >
                  <v-icon color="grey">
                    delete
                  </v-icon>
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-text-field
              v-model="newItem"
              :placeholder="label"
              outline
              :height="height"
            />
            <v-btn
              icon
              @click="create(newItem)"
            >
              <v-icon color="grey">
                add_box
              </v-icon>
            </v-btn>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            small
            @click="cancel"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </v-layout>
</template>

<script>
import * as releaseOrderPeriodsApi from "../../backend/releaseOrderPeriodsApi.js";
export default {
  props: {
    value: Array,
    label: String,
    resource: String,
    height: {
      type: [Number, String],
      default: 48,
    },
  },
  data() {
    return {
      menu: false,
      items: [],
      newItem: "",
    };
  },
  computed: {
    selectedItems() {
      return this.items.map(i => i.title);
    },
  },
  watch: {
    value: {
      handler() {
        this.initItems(this.value);
      },
      immediate: true,
    },
    menu() {
      this.initItems(this.value);
    },
  },
  methods: {
    initItems(source) {
      if (this.value && this.value.length !== 0) {
        this.items = source.map(v => {
          return { id: v.id, title: v.title };
        });
      }
    },
    async change() {
      this.menu = false;
      this.newItem = "";
      this.items = await releaseOrderPeriodsApi.getPeriods(this.resource);
      this.$emit("change", this.items);
    },
    async create(value) {
      if (this.newItem === "") {
        return;
      }
      if (this.items.length === 0) {
        this.items.push({ title: this.newItem });
        this.change();
      }
      if (!this.items.find(i => i.title === this.newItem)) {
        this.items.push({ title: this.newItem });
      }
      this.newItem = "";
      await releaseOrderPeriodsApi.createPeriod(this.resource, {
        period: value,
      });
      this.showInfo("Период добавлен");
      this.$emit("change", this.items);
    },
    async update(item) {
      await releaseOrderPeriodsApi.updatePeriod(this.resource, item.id, {
        period: item.title,
      });
      this.showInfo("Период изменен");
      this.$emit("change", this.items);
    },
    async remove(id) {
      if (confirm("Вы подтверждаете удаление периода?")) {
        const index = this.items.indexOf(this.items.find(i => i.id === id));
        this.items.splice(index, 1);
        await releaseOrderPeriodsApi.deletePeriod(this.resource, id);
        this.showInfo("Период успешно удален");
        this.$emit("change", this.items);
      }
    },
    cancel() {
      this.newItem = "";
      this.menu = false;
    },
  },
};
</script>